/* Hype Store – changement de photo au survol des cartes produit
   Au survol de la photo : affiche la 2e photo du produit.
   Quand la souris sort : revient à la photo principale.
   Uniquement sur ordinateur (souris) : le mobile garde le swipe d'origine. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function getParts(wrapper) {
    var card = wrapper.closest('product-card');
    if (!card) return null;
    var slider = card.querySelector('.product-card--image');
    var second = card.querySelector('.product-secondary-image');
    var first = card.querySelector('.product-primary-image');
    if (!slider || !second) return null;
    return { slider: slider, second: second, first: first };
  }

  function findWrapper(e) {
    return e.target && e.target.closest ? e.target.closest('.product-card--image-wrapper') : null;
  }

  document.addEventListener('mouseover', function (e) {
    var wrapper = findWrapper(e);
    if (!wrapper || (e.relatedTarget && wrapper.contains(e.relatedTarget))) return;
    var p = getParts(wrapper);
    if (!p) return;
    if (window.lazySizes && p.second.classList.contains('lazyload')) {
      try { window.lazySizes.loader.unveil(p.second); } catch (err) {}
    }
    var width = (p.first && p.first.offsetWidth) || p.slider.offsetWidth;
    p.slider.scrollTo({ left: width, behavior: 'smooth' });
  });

  document.addEventListener('mouseout', function (e) {
    var wrapper = findWrapper(e);
    if (!wrapper || (e.relatedTarget && wrapper.contains(e.relatedTarget))) return;
    var p = getParts(wrapper);
    if (!p) return;
    p.slider.scrollTo({ left: 0, behavior: 'smooth' });
  });
})();
